/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CrunchyrollBrandLightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACpklEQVR4nMVVS2gTURQdK1ixVVT8IIqxuXcqRqiiIii6UdCtoBtBV24UEa0bN0KEIib3TmyDEUFXLlyYnYgfsHTpJxtddKGIiIo/RBubzH2Jv5GXTiYz6eTXhT54m5k357xzzr13DON/LjtlrhTGM8I4pgg/CeNvYfipGD8Kw21FcLzA0WUdA08MRxYKwWVhKCtGp9kWgoIiGHIysd62wMspc4MwvA4FJHwrDA+E8L4izAlj3iNieF5KmOuaghfJ3KgYvwVB4YtiOCe8JlJ/3skasxVHdynGrBD+UYSfS4yxUPD8hdWLpt2c8Oak1b+kHeVCsE0xvhHCF05y7fzpBxgzQUsg6TjGrOp7LV8xprQ12qqKXYSjNuGpwkjfcn1m8jwuFcZxRWgFwCsvCH74CLKeDWns1uS6gkJDZrzqD9hO4CpNrjE9AkVwwuf5V11FFfB4bI4OtXEF4V2/ypobcLhk4Umffzhau5F51iNmGG5WorYF+8Ly0KRCMOIneOl9eNGMTqlCEMJfTXsgae5sHDoe8gdsu03zymfbUMsm86mtX7YFm/2eVTpW++0jHWuji78Xk7ApYE8m1qus6G6dXy1khnduRdyrSYRnrQjcoEUIrijGI1qRdkEIL9X7dcut/ac+ix63Q9BgpwIEmt21qOzwQI9Lem2mBLpMg2XFAz1TMwcdscyDbhXtmRk4qmpnB1UQHnPnT86JG116K4YnHRPU+++piBtdwnjHPXhUP9OTUQgnOrj9eNXicJI0LlCMD7VMsaI7KvWcMLcqgg8tCQhz+g/YELymZMU8xXhdCIrVUZBPxRYLQTpcDbwXgtNOPDK3JXggEwv2KoJHiuFGyerrdxV228noFpvxgE24v5yA9WHDrqOlQWzGQZ2LWLC97X/vv1p/Ab4nKBVxaOy6AAAAAElFTkSuQmCC)
 */
export const CrunchyrollBrandLightIcon = ({size = 'md', width, height, ...props}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#F78B24"
        d="M10.94 22.7a11.02 11.02 0 0 1-8.86-6.08A10.08 10.08 0 0 1 1 11.85c0-1.79.33-3.22 1.08-4.75a10.96 10.96 0 0 1 8.52-6.05c.8-.1 2.51-.07 3.27.07 1.57.28 2.98.84 4.24 1.69a10.8 10.8 0 0 1 4.86 9.64c-.03.06-.05 0-.07-.28a9.65 9.65 0 0 0-19.01-.88 9.25 9.25 0 0 0 .3 4.84 9.62 9.62 0 0 0 8.1 6.48c.67.05.5.1-.33.1-.46 0-.92-.02-1.02-.03Z"
      />
      <path
        fill="#F78B24"
        d="M13.27 21.34a7.7 7.7 0 0 1-7.06-8.7 7.7 7.7 0 0 1 6.6-6.5c.7-.1 1.94-.07 2.6.07a8.2 8.2 0 0 1 1.74.56l.39.18-.37.18a3.47 3.47 0 0 0-1.96 3.5 3.5 3.5 0 0 0 5.98 1.96c.16-.16.3-.28.3-.26.02.02.05.24.09.5a7.67 7.67 0 0 1-8.3 8.51Z"
      />
    </svg>
  );
};
